import React from 'react';
import cn from 'classnames';
import noop from 'lodash/noop';
import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import IconCheck from '@dealroadshow/uikit/core/components/Icon/IconCheck';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import { useUserPlanContext } from '@/finsight/application/User/UserPlan/UserPlanContext';
import { CURRENT_USER_PLAN_INDICATOR } from '@/finsight/ui/components/static/Pricing/PricingPlansPanel/plansConfig';
import { IPlanPanel } from '@/finsight/ui/components/static/Pricing/PricingPlansPanel/IPlanPanel';
import styles from '../styles.scss';

const PlanPanel = ({
  title,
  headTitle,
  description,
  price,
  pricePeriod,
  priceDescription,
  buttonText,
  isButtonFill,
  isButtonDisable,
  buttonLabel,
  isCurrent,
  dataTest,
  className,
  onClickButton,
  plan,
}: IPlanPanel) => {
  const { plan: currentPlan } = useUserPlanContext();
  const activePlan = plan === currentPlan;
  return (
    <div className={ cn(styles.planPanelContainer, className, { [styles.activePlan]: activePlan }) }
         data-test={ `panelPlan${ dataTest }` }>
      <div className={ styles.planPanelTop }>
        <div className={ styles.planPanelTopContent }>
          <div className={ styles.planPanelTopTitle }>
            { title }
          </div>
        </div>
      </div>

      <div className={ cn({ [styles.activePlanHeadTitle]: activePlan }, styles.planPanelHeadTitle) }>
        { activePlan ? CURRENT_USER_PLAN_INDICATOR : headTitle }
      </div>

      <div className={ styles.planPanelBottom }>
        <div className={ styles.planPanelBottomPrice }>
          <div className={ styles.planPanelBottomSubscription }>
            <span className={ styles.planPanelBottomVolume }>{ price }</span>
            <span className={ styles.planPanelBottomPeriod }>{ pricePeriod }</span>
          </div>
          <div className={ styles.planPanelBottomPrice }>
            { priceDescription }
          </div>

          <div className={ styles.planPanelBottomDescription }>
            { description }
          </div>
        </div>

        <Tooltip
          content={ buttonLabel }
          disabled={ !buttonLabel }
          wrpClassName={ styles.planPanelBottomToolTip }
          containerClassName={ styles.planPanelBottomToolTip }
        >
          <Button
            variant={ isButtonFill ? ButtonVariantType.action : ButtonVariantType.outline }
            dataTest={ `panelPlanButton${ dataTest }` }
            disabled={ isButtonDisable }
            className={ cn(styles.planPanelBottomButton, { [styles.outline]: !isButtonFill }) }
            onClick={ () => onClickButton ? onClickButton(plan) : noop() }
          >
            <div className={ styles.buttonContent }>
              {
                isCurrent && <IconCheck className={ styles.icon } />
              }
              <span className={ styles.text }>{ buttonText }</span>
            </div>
          </Button>
        </Tooltip>
      </div>
    </div>
  )
}

export default PlanPanel;
